import { checkPermission } from "@ROM/Permissions/utils";

export const canEditCompany = (user) => checkPermission(user, "company:update");
export const canManageCompanyRoles = (user) => checkPermission(user, "company:roles:manage");
export const canAccessCompanyInCompanyAdmin = (user) => canEditCompany(user) || canManageCompanyRoles(user);
